module.exports = __webpack_public_path__ + "img/dr_16.082006ff.png";